import { useTranslation } from 'react-i18next';

import type { BrandApplicationStatus } from '@nucleus-commerce/api-client/platform';

import { StatusDot, type StatusTone } from '@/shared/ui/status-dot';

const TONES: Record<BrandApplicationStatus, StatusTone> = {
  pending_email: 'muted',
  new: 'info',
  contacted: 'warning',
  approved: 'success',
  rejected: 'destructive',
  withdrawn: 'muted',
};

/** Status as a dot + word; colour alone never carries the meaning. */
export function ApplicationStatusBadge({
  status,
  className,
}: {
  status: BrandApplicationStatus;
  className?: string;
}) {
  const { t } = useTranslation('applications');
  return (
    <StatusDot tone={TONES[status]} className={className}>
      {t(`status.${status}`)}
    </StatusDot>
  );
}
